// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Content_mainContainer__nt0uU","appContent":"Content_appContent__1cSDc","main":"Content_main__2JtOo","contentPage":"Content_contentPage__1gNcJ"};